import moment from "moment";
import { icons } from "../../assets/icons";
import { displayDateFormat, voucherStatusAccordingToFinance, isVoucherInRework, containsRework, canEditVoucherAfterRework } from "../../utils/helpers";

function needToShowActionButtons(data, role) {
  // Don't show buttons if voucher is in rework
  if (isVoucherInRework(data)) {
    return false;
  }
  if(role === 'L1'){
    if(data?.newL1Status === 'Pending'){
      return true
    }else{
      return false
    }
  }else if(role === 'L2'){
    if(data?.newL2Status === 'Pending'){
      return true
    }else{
      return false
    }
  }else if(role === 'Finance'){
    // Check Finance/L3 status (A/C Status) - can be in newL3Status or Finance.status
    const financeStatus = data?.newL3Status || data?.Finance?.status || "";
    
    if (
      data?.newL1Status === "Rejected" ||
      data?.newL2Status === "Rejected" ||
      data?.newL3Status === "Approved" ||
      data?.newL3Status === "Rejected" ||
      data?.newL3Status === "Partially Approved" ||
      financeStatus === "Rework Approved" ||
      financeStatus === "ReworkApproved" ||
      financeStatus === "Rework_Approved" ||
      data?.newL3Status === "Rework Approved" ||
      data?.newL3Status === "ReworkApproved" ||
      data?.newL3Status === "Rework_Approved"
    ) {
      return false;
    }else{
      return true
    }
  }
  return false;
}

export const adminColumns = ({ onClickDownloadFile, onEditClick, userLabel, voucherData, vid, onReworkHistoryClick }) => [
  {
    Header: "Date",
    accessor: "date",
    Cell: (rowData) => {
      return <div>{moment(rowData?.date).format(displayDateFormat)}</div>;
    },
  },
  {
    Header: "Voucher Head",
    accessor: "head",
    Cell: (rowData) => {
      const value = rowData;

      return (
        <div className="py-4 max-w-[20rem]">
          <div className="font-size-small font-family-regular">
            {value?.head}
          </div>
        </div>
      );
    },
  },
  { 
    Header: "Amount (₹)", 
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
   },
  { Header: "Voucher Comment", accessor: "comment" },
  {
    Header: "L1 Status",
    accessor: "l1_status",
    Cell: (rowData) => {
      const value = rowData?.L1?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : containsRework(value)
              ? "text-[#FF8C00]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "L2 Status",
    accessor: "l2_status",
    Cell: (rowData) => {
      const value = rowData?.L2?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : containsRework(value)
              ? "text-[#FF8C00]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "A/C Status",
    accessor: "ac_status",
    Cell: (rowData) => {
      const value = rowData?.Finance?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : containsRework(value)
              ? "text-[#FF8C00]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "Approved Amount (₹)",
    accessor: "approved_amount",
    Cell: (rowData) => {
      const value = rowData?.approved_amount || rowData?.finance_amount_approved;
      return value ? Number(value).toFixed(2) : "-";
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: (rowData) => {
      // Merge voucher data with row data to check rework status from both sources
      // Row data might have L1/L2/L3 status fields that indicate rework
      const voucherToCheck = {
        ...voucherData,
        ...rowData,
        // Ensure status fields from row are included
        L1: rowData?.L1 || voucherData?.L1,
        L2: rowData?.L2 || voucherData?.L2,
        L3: rowData?.L3 || voucherData?.L3,
        Finance: rowData?.Finance || voucherData?.Finance,
        newL1Status: rowData?.newL1Status || rowData?.L1?.status || voucherData?.newL1Status,
        newL2Status: rowData?.newL2Status || rowData?.L2?.status || voucherData?.newL2Status,
        newL3Status: rowData?.newL3Status || rowData?.L3?.status || voucherData?.newL3Status,
        // Finance status is stored in Finance.status (for A/C Status column)
        financeStatus: rowData?.Finance?.status || voucherData?.Finance?.status,
      };
      const canEdit = onEditClick && canEditVoucherAfterRework(voucherToCheck, userLabel);
      const hasFile = rowData?.filename;

      if (!hasFile && !canEdit) {
        return null;
      }

      return (
        <div className="flex items-center gap-x-7">
          {canEdit && (
            <img
              alt="edit icon"
              className="cursor-pointer"
              src={icons.editIcon}
              onClick={() => onEditClick(rowData)}
              title="Edit Voucher"
            />
          )}
          {hasFile && (
            <img
              alt="download icon"
              className="cursor-pointer"
              src={icons.downloadIcon}
              onClick={() =>
                onClickDownloadFile(
                  rowData?.file_id,
                  rowData?.filename
                )
              }
            />
          )}
          {/* Rework History Button - Show for all voucher types */}
          {onReworkHistoryClick && (
            <img
              src={icons.loopIcon}
              alt="rework history icon"
              className="cursor-pointer"
              title="View Rework History"
              onClick={() => {
                // Use parent voucher ID (vid) if available, otherwise use rowData id
                const voucherIdToUse = vid || rowData?.id || rowData?.vid;
                if (voucherIdToUse) {
                  onReworkHistoryClick(voucherIdToUse);
                }
              }}
            />
          )}
        </div>
      );
    },
  },
];

export const areaManagerColumns = ({ 
  onClickViewFile, 
  vid, 
  userLabel, 
  voucherType, 
  setIsEditVoucherCommentVisible, 
  getFile,
  decisionStatusMap = {}, // Track decision status per sub-voucher
  onReworkHistoryClick // Handler for rework history button
}) => [
  {
    Header: "Voucher Head",
    accessor: "head",
  },
  {
    Header: "ID",
    accessor: "id",
    Cell: (props) => {
      return (
        <div className="">
          <div>{vid|| "-"}</div>
        </div>
      );
    },
  },
  {
    Header: "E.ID",
    // accessor: "childId",
    Cell: (rowData) => {
      return (
        <div className="">
          <div>{rowData?.childId || "-"}</div>
        </div>
      );
    },
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
  },
  {
    Header: "L1 Status",
    Cell: (rowData) => {
      const status = rowData?.newL1Status || rowData?.L1?.status;
      return (
        <div className="">
          <div
            className={
              status === "Approved"
                ? "text-[var(--successGreen)]"
                : status === "Rejected"
                ? "text-[var(--textRed)]"
                : status === "Pending"
                ? "text-[var(--pendingYellow)]"
                : status === "Partially Approved"
                ? "text-[var(--pendingYellow)]"
                : containsRework(status)
                ? "text-[#FF8C00]"
                : ""
            }
          >
            {status || "-"}
          </div>
          {/* Show decision status badge if decision is made */}
          {decisionStatusMap[rowData?.id] && decisionStatusMap[rowData?.id] === "Approved" && (
            <div className="text-[1.2rem] font-medium text-[var(--successGreen)]">
              (saved)
            </div>
          )}
          {decisionStatusMap[rowData?.id] && decisionStatusMap[rowData?.id] === "Rejected" && (
            <div className="text-[1.2rem] font-medium text-[var(--textRed)]">
              (saved)
            </div>
          )}
        </div>
      );
    },
  },
  {
    Header: "L1 Comment",
    Cell: (rowData) => {
      return (
        <div className="">
          {rowData?.newL1ActionComment || "-"}
        </div>
      );
    },
  },
  {
    Header: "L2 Status",
    Cell: (rowData) => {
      const status = rowData?.newL2Status || rowData?.L2?.status;
      return (
        <div className="">
          <div className="">
            <div
              className={
                status === "Approved"
                  ? "text-[var(--successGreen)]"
                  : status === "Rejected"
                  ? "text-[var(--textRed)]"
                  : status === "Pending"
                  ? "text-[var(--pendingYellow)]"
                  : status === "Partially Approved"
                  ? "text-[var(--pendingYellow)]"
                  : containsRework(status)
                  ? "text-[#FF8C00]"
                  : ""
              }
            >
              {status || "-"}
            </div>
          </div>
          {/* Show decision status badge if decision is made */}
          {decisionStatusMap[rowData?.id] && decisionStatusMap[rowData?.id] === "Approved" && (
            <div className="text-[1.2rem] font-medium text-[var(--successGreen)]">
              (saved)
            </div>
          )}
          {decisionStatusMap[rowData?.id] && decisionStatusMap[rowData?.id] === "Rejected" && (
            <div className="text-[1.2rem] font-medium text-[var(--textRed)]">
              (saved)
            </div>
          )}
        </div>
      );
    },
  },
  {
    Header: "L2 Comment",
    Cell: (rowData) => {
      return (
        <div className="">
          {rowData?.newL2ActionComment || "-"}
        </div>
      );
    },
  },
  {
    Header: "A/C Status",
    Cell: (rowData) => {
      const status = rowData?.newL3Status || rowData?.L3?.status || rowData?.Finance?.status;
      return (
        <div className="">
          <div className="">
            <div
              className={
                status === "Approved"
                  ? "text-[var(--successGreen)]"
                  : status === "Rejected"
                  ? "text-[var(--textRed)]"
                  : status === "Pending"
                  ? "text-[var(--pendingYellow)]"
                  : status === "Partially Approved"
                  ? "text-[var(--pendingYellow)]"
                  : containsRework(status)
                  ? "text-[#FF8C00]"
                  : ""
              }
            >
              {status || "-"}
            </div>
          </div>
          {/* Show decision status badge if decision is made */}
          {decisionStatusMap[rowData?.id] && decisionStatusMap[rowData?.id] === "Approved" && (
            <div className="text-[1.2rem] font-medium text-[var(--successGreen)]">
              (saved)
            </div>
          )}
          {decisionStatusMap[rowData?.id] && decisionStatusMap[rowData?.id] === "Rejected" && (
            <div className="text-[1.2rem] font-medium text-[var(--textRed)]">
              (saved)
            </div>
          )}
        </div>
      );
    },
  },
  {
    Header: "A/C Comment",
    Cell: (rowData) => {
      return (
        <div className="">
          {rowData?.newL3ActionComment || "-"}
        </div>
      );
    },
  },
  {
    Header: "Approved Amount(₹)",
    accessor: "approvedAmount",
    Cell: (props) => {
      // debugger
      const value = props?.finance_amount_approved ||
      props?.l2_amount_approved ||
      props?.l1_amount_approved || "-"
      return (
        <div>{value ? Number(value).toFixed(2) : '-'}</div>
      );
    }
  },
  {
    Header: "Comment",
    accessor: "comment",
    Cell: (props) => {
      return (
        <div>
          {props?.comment ? props?.comment : '-'}
          {userLabel === "Finance" && 
          <img
              src={icons.editIcon}
              alt="view icon"
              className="cursor-pointer w-6 h-6 mt-2 mb-2"
              onClick={() => {
                setIsEditVoucherCommentVisible(
                  {
                    isOpen: true,
                    data: {
                      id: props?.id,
                      comment: props?.comment
                    }
                  }
                )  
              }}
            /> }
        </div>
      );
    }
  },
  {
    Header: "Actions",
    accessor: "file_id",
    Cell: (rowData) => { 
      return (
        <div className="flex items-center gap-x-5">
          {(voucherType === "Pending" || voucherType === "All") && (
            <>
              <img
                src={icons.downloadIcon}
                alt="attachment icon"
                className="cursor-pointer"
                onClick={() => {
                  getFile(rowData?.id, (data) => {
                    const url = window.URL.createObjectURL(
                      new Blob([data.data])
                    );
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = rowData?.filename;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                  });
                }}
              />
              <img
                src={icons.squareEyeIcon}
                alt="view icon"
                className="cursor-pointer"
                onClick={() => {
                  return onClickViewFile(rowData?.id, rowData)
                }}
              />
            </>
          )}
          {/* { voucherStatusAccordingToFinance({ vType: voucherType, userType: userLabel }).label === "Attachment" ? <div
            className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
            onClick={() => {
              return onClickViewFile(rowData?.id, rowData)
            }}
          >
            View
          </div> : voucherStatusAccordingToFinance({ vType: voucherType, userType: userLabel })?.value
             } */}
        </div>
      );
    },
  },
  {
    Header: voucherStatusAccordingToFinance({ vType: voucherType, userType: userLabel })?.label || "Status",
    accessor: "file_id",
    Cell: (rowData) => { 
      return (
        <div className="flex items-center gap-x-5">
          { voucherStatusAccordingToFinance({ vType: voucherType, userType: userLabel }).label === "Attachment" ? <div
            className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
            onClick={() => {
              return onClickViewFile(rowData?.id, rowData)
            }}
          >
            View
          </div> : voucherStatusAccordingToFinance({ vType: voucherType, userType: userLabel })?.value
             }
        </div>
      );
    },
  },
];

export const areaManagerSubheadColumns = () => [
  {
    Header: "Sub Head",
    accessor: "subhead",
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
  },
  {
    Header: "Approved Amount(₹)",
    accessor: "approvedAmount",
    Cell: (props) => {
      // debugger
      const value = props?.finance_amount_approved ||
      props?.l2_amount_approved ||
      props?.l1_amount_approved || "-"
      return (
        <div>{value ? Number(value).toFixed(2) : '-'}</div>
      );
    }
  },
  {
    Header: "Invoices",
    accessor: "invoices",
    Cell: (rowData) => {
      return <div>{rowData?.subRows?.length}</div>;
    },
  },
];

export const areaManagerNestedSubheadColumns = ({ onClickDownloadFile, vid }) => [
  // {
  //   Header: "Sub Head",
  //   accessor: "sub_head",
  // },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
  },
  {
    Header: "Approved Amount(₹)",
    // accessor: "approvedAmount",
    Cell: (props) => {
      // debugger
      const value = props?.finance_amount_approved ||
      props?.l2_amount_approved ||
      props?.l1_amount_approved || "-"
      return (
        <div>{value ? Number(value).toFixed(2) : '-'}</div>
      );
    }
  },
  {
    Header: "Date",
    accessor: "date",
  },
  {
    Header: "Comment",
    accessor: "comment",
  },
  {
    Header: "Attachment",
    accessor: "file_id",
    Cell: (rowData) => {
      return (
        <div
          className="cursor-pointer text-[#346BFF] underline"
          onClick={() => onClickDownloadFile(rowData?.id, rowData?.filename)}
        >
          Download
        </div>
      );
    },
  },
];
